import { SEPARATOR } from '@hakimo-ui/hakimo/data-access';
import { AudioFilterValues } from '@hakimo-ui/hakimo/types';

export function getCameraFilterParamsFromAudioFilters(
  audioFilters: AudioFilterValues
): string {
  const params = new URLSearchParams();

  if (audioFilters.location.values.length > 0) {
    params.append(
      'locations',
      audioFilters.location.values.map((loc) => loc.name).join(SEPARATOR)
    );
  }
  return params.toString();
}

export function getLocationNamesFromFilterParams(
  filterParams?: string
): string[] {
  if (!filterParams) return [];
  const params = new URLSearchParams(filterParams);
  const locationsParam = params.get('locations');
  if (!locationsParam) return [];
  return locationsParam.split(SEPARATOR);
}

export function getSearchParams(
  page: number,
  pageSize: number,
  audioFilters: AudioFilterValues
): string {
  const params = new URLSearchParams();
  params.append('page', String(page));
  params.append('pageSize', String(pageSize));
  params.append('isEnabled', String(FILTER_ENABLED_DEVICES_ONLY));
  if (audioFilters.location.values.length > 0) {
    params.append(
      'locationIds',
      audioFilters.location.values.map((loc) => loc.id).join(SEPARATOR)
    );
  }
  return params.toString();
}

export const MIN_GAP_SECONDS = 0;
export const MAX_GAP_SECONDS = 120;
export const FILTER_ENABLED_DEVICES_ONLY = true;
